/**
 * Runtime config from Vite build-time env (VITE_*). See HLD §6/§8.
 * Use `||` (not `??`): a Docker build without the build arg bakes an EMPTY
 * string, which must fall back to the default — otherwise API calls go
 * same-origin against the nginx SPA container and break.
 */
export const env = {
  apiBase: import.meta.env.VITE_API || 'https://api.greffon.local',
  domain: import.meta.env.VITE_DOMAIN || 'greffon.local',
  protocol: import.meta.env.VITE_PROTOCOL || 'https',
} as const;
